
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53.935 24.465h-7c-1.26 0-1.715-1.225-2.695-1.715-.035 0-.035-.105-.035-.14v-4.55c.63-.035 1.12-.175 1.575.42 1.26 1.575 3.465 1.68 4.9.35 1.4-1.26 1.435-3.535.07-4.9-1.4-1.4-3.535-1.33-4.935.105-.245.245-.63.42-.98.42-2.66.035-5.32 0-7.98.035-.49 0-.84-.105-1.19-.49-1.365-1.435-3.465-1.47-4.865-.07-1.33 1.365-1.295 3.5.105 4.83s3.57 1.26 4.865-.245c.49-.595.98-.63 1.645-.455v4.41c0 .14-.07.315-.175.42-1.575 1.47-1.68 1.505-3.815 1.54h-4.97c-2.24 0-4.445-.035-6.685.035-2.415.035-4.34 2.065-4.34 4.48v6.195h-1.54c-.595 0-.945.28-.98.91v2.94c0 .63.35.875.98.875h4.9l-4.69 7.84a6.085 6.085 0 001.33 7.42l.455.42a5.906 5.906 0 008.085-.245l.14-.14c1.89-1.89 2.31-4.795 1.05-7.175L22.4 39.9h5.075c.63 0 .945-.28.945-.91v-2.17c0-1.61 0-1.61-1.645-1.68-.105 0-.175-.035-.245-.07v-1.54h8.19c.525 0 .875.14 1.26.525 2.73 2.66 7.175 2.625 9.835-.07.315-.315.63-.42 1.05-.42h7.07c.945 0 1.155-.175 1.155-1.12V25.62c0-.98-.21-1.155-1.155-1.155zm-5.53-10.08c1.085 0 1.96.875 1.96 1.96s-.875 1.96-1.96 1.96a1.957 1.957 0 01-1.96-1.96c.035-1.085.91-1.96 1.96-1.96zm-15.12 3.92a1.957 1.957 0 01-1.96-1.96c0-1.085.875-1.96 1.96-1.96s1.96.875 1.96 1.96-.875 1.96-1.96 1.96zM26.95 36.61v1.785H16.38V36.61h10.57zm15.82-14.56h-3.815v-3.99h3.815v3.99z","fill":"#27AE60"}})])
          )
        }
      }
    